<template>
  <div v-if="currentCommande">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Commandes'"
          :description="'Aperçu d\'une commande'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentCommande.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 text-custom-primary">
                    Référence : {{ currentCommande.document.reference }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_commande' }).catch(() => {})
          "
        >
          Liste des commandes
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_commande-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle commande
        </button>

        <button
          v-if="
            currentCommande.facturation === 0 && currentCommande.reception === 0
          "
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'achat_commande-edit',
                params: { id: currentCommande.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
      <div
        class="col-md-12 col-lg-6"
        v-if="
          currentCommande.facturation < 100 || currentCommande.reception < 100
        "
      >
        <button
          v-if="currentCommande.facturation < 100"
          type="button"
          title="Tranformer en facture"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'facture-create',
                params: { filter: 'cmd', id: currentCommande.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-share-square font-size-17"></i> Facturation
        </button>

        <button
          v-if="currentCommande.reception < 100"
          type="button"
          title="Tranformer en réception"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'reception-create',
                params: { filter: 'cmd', id: currentCommande.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-share-square font-size-17"></i> Réception
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'achat_commande-show',
                params: { id: currentCommande.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Commande</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'achat_commande_show-document',
                params: {
                  id: currentCommande.id,
                  documentUuid: currentCommande.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/commande';
export default {
  data() {
    return {
      currentCommande: null,
      id: null,
      title: 'Gestion des commandes - Aperçu',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      window.axios
        .get(URL.COMMANDE + '/' + this.$route.params.id)
        .then((resp) => {
          this.currentCommande = resp.data.commande_achat;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
